import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M10.6 1.5a5.9 5.9 0 100 11.8 5.9 5.9 0 000-11.8zM3.7 7.4a6.9 6.9 0 112.433 5.26L1.35 17.357l-.7-.714 4.77-4.684A6.876 6.876 0 013.7 7.4z" fill="currentcolor" /></svg>;